import React from 'react';
import { string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';

import './style.scss';

const GroupHeader = ({ labelKey }) => (
    <div className="seller-group-header tbody-7 p-l-16 m-b-8 m-t-8">
        <I18n k={labelKey} />
    </div>
);

GroupHeader.propTypes = {
    labelKey: string.isRequired,
};

export default GroupHeader;
